import leftSidebarStore      from '@/TokamapEditor/stores/leftSidebarStore';
import decorStore            from '@/TokamapEditor/decor/decorStore';
import { DecorCatalogue }    from '@/TokamapEditor/decor/DecorSidebarPanels';
import { DecorItemActions }  from '@/TokamapEditor/decor/DecorSidebarPanels';
import { DecorItemPanel }    from '@/TokamapEditor/decor/DecorSidebarPanels';
import { DecorItemSubtitle } from '@/TokamapEditor/decor/DecorSidebarPanels';
import { DecorItemTitle }    from '@/TokamapEditor/decor/DecorSidebarPanels';

const SIDEBAR_WIDTH = 360;

export function openDecorCatalogue() {
	leftSidebarStore.open({
		reference: 'decor',
		title: 'Mobilier & Déco',
		subTitle: 'Choisissez un élément, puis cliquez sur la carte',
		render: () => <DecorCatalogue />,
		closeButton: true,
		bordered: true,
		overlay: false,
		width: SIDEBAR_WIDTH,
		onClose: () => decorStore.arm(null),
	});
}

export function openDecorItemSidebar(id: string) {
	leftSidebarStore.open({
		reference: 'decor-item',
		title: <DecorItemTitle />,
		subTitle: <DecorItemSubtitle />,
		render: () => <DecorItemPanel />,
		footer: <DecorItemActions />,
		closeButton: true,
		bordered: true,
		overlay: false,
		width: SIDEBAR_WIDTH,
		onClose: () => decorStore.cancelPath(),
	});
	decorStore.select(id);
}
